import { render } from "./ActionBoxes.vue?vue&type=template&id=15123b3d&scoped=true"
import script from "./ActionBoxes.vue?vue&type=script&lang=js"
export * from "./ActionBoxes.vue?vue&type=script&lang=js"

import "./ActionBoxes.vue?vue&type=style&index=0&id=15123b3d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15123b3d"]])

export default __exports__